import { ActionReducerMap } from '@ngrx/store';
import { UserPermStates } from '../states';

import * as fromUserPermReducers from './user-permissions.reducers';

export const userPermReducers: ActionReducerMap<UserPermStates> = {
    userPerm: fromUserPermReducers.userPermReducer
};